module.exports = __webpack_public_path__ + "img/iniciativa-popular.a0ec3db7.png";